import styled, { createGlobalStyle } from 'styled-components';
import { token } from '@zillow/constellation';

export const AppContainer = styled.div`
  height: 100%;
  min-height: 100vh;
  width: 100%;
`;

export const FooterContainer = styled.div`
  min-width: 100%;
  background-color: ${token('colors.white')};
`;

export const GlobalStyle = createGlobalStyle`
    body {
        font-family:"Open Sans";
    }
`;
